export default {
  SET_COMPANIES(state, payload) {
    state.companies = payload
  },
}
